export const getModuleLink = item => {
    const { id, basePath = '' } = item;
    const destinationPath = `${basePath}/${id}`;

    return destinationPath;
};
